import React from 'react';
import { RealEstateDetail } from 'src/Components/RealEstateDetail';
var RealEstateDetailPage = function () { return React.createElement(RealEstateDetail, null); };
export default RealEstateDetailPage;
